import { Component, Input } from '@angular/core';

@Component({
    selector: 'create-source-preview-results',
    template: `
        <mat-card *ngIf="results && !match" style="margin-top: 1px;">
            <mat-card-header fxLayout="colunm">
                <mat-card-title>{{results.title}}</mat-card-title>
                <mat-card-subtitle *ngIf="results.description">{{results.description}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <table mat-table [dataSource]="results?.items" style="width: 100%">
                    <ng-container matColumnDef="title">
                        <td mat-cell *matCellDef="let row">{{row.title}}</td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <td mat-cell *matCellDef="let row">{{row.publishedDate | amTimeAgo}}</td>
                    </ng-container>

                    <tr mat-row *matRowDef="let row; columns: ['title', 'date'];"></tr>
                </table>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="!results && match" style="margin-top: 1px;">
            <mat-card-header fxLayout="colunm">
                <mat-card-title>This source already exists</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <span *ngIf="match.tenantId">
                    Edit existing source: <a [routerLink]="['/settings', 'sources', match.id]">{{match.title}}</a> 
                </span>
                <span *ngIf="!match.tenantId">
                    This source already exists in Attensa's Shared Resources Catalog.
                    It is available to be included in topics you create. 
                    Just look for {{match.title}}. 
                </span>
            </mat-card-content>
        </mat-card>
    `
})
export class CreateSourcePreviewResultsComponent {
    @Input() results: {title, description?, items: {title, publishedDate}[]};
    @Input() match: { id, title, description?, tenantId? };
}
